import {
  CalendarDays,
  KeyRound,
  LogOut,
  Mail,
  ShieldCheck,
  UserRound,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '../components/AppShell';
import { Avatar } from '../components/Avatar';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { useAuth } from '../context/AuthContext';
import { formatDateTime } from '../lib/format';

export function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate('/');
  };

  if (!user) return null;

  return (
    <AppShell>
      <div className="mx-auto max-w-3xl">
        <div className="mb-8">
          <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-zinc-600">Аккаунт</p>
          <h1 className="mt-2 text-3xl font-semibold tracking-[-0.04em] text-white">Профиль</h1>
        </div>

        <div className="overflow-hidden rounded-2xl border border-white/[0.07] bg-[#0c0e14]/80">
          <div className="relative border-b border-white/[0.06] px-6 py-8">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_10%_0%,rgba(139,92,246,0.09),transparent_50%)]" />
            <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center">
              <Avatar name={user.displayName} size="lg" />
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h2 className="truncate text-xl font-semibold tracking-tight text-white">
                    {user.displayName}
                  </h2>
                  <Badge tone="emerald">
                    <ShieldCheck className="size-3" />
                    Активный аккаунт
                  </Badge>
                </div>
                <p className="mt-1 flex items-center gap-1.5 text-[13px] text-zinc-500">
                  <Mail className="size-3.5" />
                  {user.email}
                </p>
              </div>
            </div>
          </div>

          <div className="grid gap-px bg-white/[0.05] sm:grid-cols-2">
            <div className="bg-[#0c0e14] px-6 py-5">
              <p className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-zinc-600">
                <CalendarDays className="size-3" />
                Аккаунт создан
              </p>
              <p className="mt-2 text-[13px] text-zinc-300">{formatDateTime(user.createdAt)}</p>
            </div>
            <div className="bg-[#0c0e14] px-6 py-5">
              <p className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-zinc-600">
                <UserRound className="size-3" />
                Последний вход
              </p>
              <p className="mt-2 text-[13px] text-zinc-300">{formatDateTime(user.lastLoginAt)}</p>
            </div>
          </div>

          <div className="flex flex-col gap-3 border-t border-white/[0.06] px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg border border-white/[0.06] bg-white/[0.02]">
                <KeyRound className="size-3.5 text-zinc-500" />
              </span>
              <div>
                <p className="text-[13px] text-zinc-300">Пароль и сессии</p>
                <p className="mt-0.5 text-[11px] leading-relaxed text-zinc-600">
                  Пароль хранится как Argon2id-хеш. Сессии серверные, cookie HttpOnly.
                </p>
              </div>
            </div>
            <Button variant="danger" onClick={() => void onLogout()} className="shrink-0">
              <LogOut className="size-4" />
              Выйти из аккаунта
            </Button>
          </div>
        </div>

        <div className="mt-4 rounded-2xl border border-white/[0.06] bg-white/[0.012] px-5 py-4">
          <p className="text-[11px] leading-relaxed text-zinc-600">
            Смена пароля и управление почтой появятся в следующей версии. Восстановление доступа
            через email пока не подключено.
          </p>
        </div>
      </div>
    </AppShell>
  );
}
